import { EventType, type IPublicClientApplication } from '@azure/msal-browser';
import { createAuthInsights } from '../config/authInsightsRuntime';
import { getAnalyticsConsent } from './consent';
import { isAnalyticsActive, subscribeAnalyticsConsent } from './gaEvents';
import { insight } from './productInsights';

const runtime = createAuthInsights({
  getAnalyticsConsent, isAnalyticsActive, subscribeAnalyticsConsent, insight,
  // Access storage lazily: browser storage may throw even when resolving the property.
  storage: {
    getItem: (key: string) => sessionStorage.getItem(key),
    setItem: (key: string, value: string) => sessionStorage.setItem(key, value),
    removeItem: (key: string) => sessionStorage.removeItem(key),
  },
  eventTypes: EventType,
});
export function installAuthInsights(instance: IPublicClientApplication): void { runtime.install(instance); }
export function recordAuthProfile(ok: boolean, error?: unknown): void { runtime.recordProfile(ok, error); }
